const NavigationLinks = () => {
  return [
    { label: 'Home', url: '/', isHeader: true },
    { label: 'Videos', url: '/videos', isHeader: true },
    { label: 'Startup Evaluation', url: '/evaluation', isHeader: true },
    {
      label: 'Blogs',
      url: 'https://blogs.lovencoders.com/',
      isHeader: true,
      isRedirect: true,
      onClick: () => sessionStorage.setItem("previousPage", window.location.pathname),
    },
    { label: 'Offerings', url: '/offerings', isHeader: true },
    { label: 'Success Stories', url: '/success-stories', isHeader: true },
    { label: 'Contact Us', url: '/contact-us', isFooter: true, isHeader: true },
    { label: 'About Us', url: '/about-us', isFooter: true, isHeader: true },
    { label: 'Privacy Policy', url: '/privacy-policy', isFooter: true, isHeader: false },
  ];
};

export default NavigationLinks;
